import { db } from "../lib/firebaseApp"
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc
} from "firebase/firestore";
import { f_recursive_delete } from "./fbFunctions";



// ============================================== CATEGORY =============================================



// ------------------------------------------------------------------------
export const add_Category = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "EVENTS", event_id, "CATEGORIES"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Category:\n", error, user_id, event_id, data)
        }
        return(undefined)
    }
}


// ------------------------------------------------------------------------
export const edit_Category = async (user_id, event_id, category_id, data, cb_error) => {
    console.log(user_id, event_id, category_id, data, )
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id, "CATEGORIES", category_id), {
            ...data,
            id: category_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Category:\n", error)
        }
        return(undefined)
    }
}

// ------------------------------------------------------------------------
export const delete_Category = async (event_id, category_id, cb_error) => {
    try {
            const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "CATEGORIES", category_id)))
            if (docSnap.exists()) {
                await deleteDoc(doc(db, "EVENTS", event_id, "CATEGORIES", category_id));
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> delete_Category:\n", error)
        }
            return(undefined)
        }
}

// ------------------------------------------------------------------------
export const get_Category_byID = async (event_id, category_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "CATEGORIES", category_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Category_byID:\n", error)
        }
        return(undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Category_list = async (event_id, cb_error) => {
    try {
        const category_list = []
        console.log("event_id: ", event_id)
        const querySnapshot = await getDocs(collection(db, "EVENTS", event_id, "CATEGORIES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const category_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", category_data);
            category_list.push(category_data)
        });
        return (category_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Category_list:\n", error)
        }
        return([])
    }
}

// ------------------------------------------------------------------------
export const get_Category_dict = async (event_id, cb_error) => {
    try {
        let category_dict = {}
        const querySnapshot = await getDocs(collection(db, "EVENTS", event_id, "CATEGORIES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const category_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", category_data);
            category_dict[category_data.id] = category_data
        });
        return (category_dict)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Category_dict:\n", error)
        }
        return( {} ) 
    }
}



// ----------------------------------------------------------------------------
/**
 * Cancella la collection CATEGORIES e tutti documenti category al suo interno
 * 
 * @param {string} event_id - id dell'evento da cui cancellare la collection 
 * @returns 
 */
export const clear_all_category = async (event_id) => {
    console.log("clear_all_category ", event_id)
    
    const path = "EVENTS/" + event_id + "/CATEGORIES"
    const res = await f_recursive_delete({ path})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.path;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in clear_all_category cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}


